import script from "./Trading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trading.vue?vue&type=script&setup=true&lang=ts"

import "./Trading.vue?vue&type=style&index=0&id=1a279a8d&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a279a8d"]])

export default __exports__